import React, { useCallback, useLayoutEffect, useState } from 'react';
import { KeyboardAvoidingView } from 'react-native-keyboard-controller';
import { useNavigation, useRoute, useIsFocused } from '@react-navigation/native';
import { createGroupChannelFragment, useSendbirdChat } from '@sendbird/uikit-react-native';
import { useGroupChannel } from '@sendbird/uikit-chat-hooks';
import {
    withSendbirdConnection,
    CustomChatHeader,
    ChatEmptyConversation,
    ChatMessageRenderer,
    ChatMediaModal,
    ChatComposer,
    ChatThreadSkeleton,
    ChatThreadConnecting,
    ChatMessagesFlatList,
} from '../components';
import { ChatRetryContext } from '../contexts';
import { useChatMediaViewer } from '../hooks/useChatMediaViewer';
import { IGroupChannelContentProps } from '../types';

const UseReactNavigationHeader = () => null;

const GroupChannelFragment = createGroupChannelFragment({
    Header: UseReactNavigationHeader,
    Input: ChatComposer,
    StatusEmpty: ChatEmptyConversation,
    StatusLoading: ChatThreadSkeleton,
});

const GroupChannelThread = () => {
    const navigation = useNavigation<any>();
    const { params } = useRoute<any>();
    const { sdk } = useSendbirdChat();
    const { channel } = useGroupChannel(sdk, params.channelUrl);
    const isFocused = useIsFocused();
    const { media, openMedia, closeMedia } = useChatMediaViewer();

    useLayoutEffect(() => {
        navigation.setOptions({
            headerShown: false,
        });
    }, [navigation]);

    if (!channel) {
        return <ChatThreadConnecting />;
    }

    return (
        <KeyboardAvoidingView style={{ flex: 1 }} behavior="padding">
            <CustomChatHeader
                channel={channel}
                onPressLeft={() => navigation.goBack()}
            />
            {isFocused && (
                <GroupChannelFragment
                    channel={channel}
                    enableMessageGrouping
                    flatListComponent={ChatMessagesFlatList}
                    onPressMediaMessage={openMedia}
                    renderMessage={(props) => <ChatMessageRenderer {...props} />}
                    onChannelDeleted={() => {
                        navigation.navigate('GroupChannelList');
                    }}
                    onPressHeaderLeft={() => {
                    }}
                    onPressHeaderRight={() => {
                    }}
                />
            )}
            <ChatMediaModal media={media} onClose={closeMedia} />
        </KeyboardAvoidingView>
    );
};

const GroupChannelContent: React.FC<IGroupChannelContentProps> = () => {
    const [attempt, setAttempt] = useState(0);
    const retry = useCallback(() => setAttempt(value => value + 1), []);

    return (
        <ChatRetryContext.Provider value={retry}>
            <GroupChannelThread key={attempt} />
        </ChatRetryContext.Provider>
    );
};

export const GroupChannelScreen = withSendbirdConnection(
    GroupChannelContent,
    {
        useDetailedConnectionStatus: false,
        ConnectingComponent: ChatThreadConnecting,
    }
);
